export default "__VITE_ASSET__Bxv20N_7__"